import axios from "~/plugins/axios";
import CartService from "~/service/cartService";

export default {
  list() {
    return axios.get("/ebsn/api/payment-giftcard-type/list").then(data => {
      return data.data.data.paymentGiftCards;
    });
  },

  select(paymentTypeId, select) {
    return axios
      .post("/ebsn/api/payment-giftcard-type/select", null, {
        params: {
          payment_type_id: paymentTypeId,
          select: select
        }
      })
      .then(data => {
        CartService.getCart(true);
        return data.data.data.paymentGiftCards;
      });
  },

  logout(paymentTypeId) {
    return axios
      .post("/ebsn/api/payment-giftcard-type/logout", {
        params: { payment_type_id: paymentTypeId }
      })
      .then(data => {
        return data.data.data.paymentGiftCards;
      });
  },

  removeGiftcard(paymentTypeId, cardId) {
    return axios
      .post("/ebsn/api/payment-giftcard-type/remove-giftcard", null, {
        params: {
          payment_type_id: paymentTypeId,
          card_id: cardId
        }
      })
      .then(data => {
        return data.data.data;
      });
  },

  addNewGiftcard(paymentTypeId, data) {
    return axios
      .post("/ebsn/api/payment-giftcard-type/add-new-giftcard", data, {
        params: { payment_type_id: paymentTypeId }
      })
      .then(data => {
        return data.data.data;
      });
  },

  getCami(paymentTypeId) {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/detail", {
        params: { payment_type_id: paymentTypeId }
      })
      .then(data => {
        return data.data.data;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },

  prepareGiftCards(paymentTypeId) {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/prepare-giftcards", {
        params: { payment_type_id: paymentTypeId }
      })
      .then(data => {
        return data.data.data;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },

  update(paymentTypeId, data) {
    //sull'url il parametro, nel body il json
    return axios
      .post("/ebsn/api/payment-giftcard-type/update-data", data, {
        params: { payment_type_id: paymentTypeId }
      })
      .then(data => {
        return data.data.data;
      });
  }

  /*
  validateToken(token) {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/mobile-callback", {
        params: { code: token }
      })
      .then(data => {
        return data;
      });
  },
  validateTokenTC(token) {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/mobile-callback-tc", {
        params: { code: token }
      })
      .then(data => {
        return data;
      });
  },
  validateLogoutToken() {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/mobile-logout")
      .then(data => {
        return data;
      });
  },
  validateLogoutTokenTC() {
    return axios
      .get("/ebsn/api/payment-giftcard/cami/mobile-logout-tc")
      .then(data => {
        return data;
      });
  },
  */
};
